export default __webpack_public_path__ + "static/media/Cook.3c5942dc.png";